import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskWorkforceOptimizationRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-workforce-optimization',
	path: '/jira/servicedesk/projects/:projectKey/settings/workforce-optimization',
	exact: true,
};
